(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-account-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  const drawer = document.getElementById('mm-account-drawer');
  if (!drawer || !drawer.showModal) return;
  let opener;
  document.addEventListener('click', event => {
    const link = event.target.closest('.header-menu-account, [data-mm-account-open]');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    opener = link;
    if (!drawer.open) drawer.showModal();
    document.documentElement.classList.add('mm-account-open');
    drawer.querySelector('input').focus();
  });
  drawer.querySelector('[data-mm-account-close]').addEventListener('click', () => drawer.close());
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const rect = drawer.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) drawer.close();
  });
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('mm-account-open');
    if (opener?.isConnected) opener.focus();
  });
  drawer.querySelector('[data-mm-account-form]').addEventListener('submit', event => {
    const url = new URL(drawer.dataset.loginUrl, location.origin);
    url.searchParams.set('login_hint', drawer.querySelector('input').value.trim());
    event.preventDefault();
    location.assign(url.href);
  });
  window.addEventListener('pageshow', () => { if (drawer.open) drawer.close(); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-customer-address-form"] && !Shopify.designMode) return;
  try {
    function mmInitCustomerAddress() {
  const country = document.getElementById('MMAddress-country');
  const province = document.getElementById('MMAddress-province');
  const container = document.getElementById('MMAddress-province-container');
  if (!country || !province || !container) return;
  const initial = country.dataset.default;
  const selected = Array.from(country.options).find(option => option.value === initial || option.textContent.trim() === initial);
  if (selected) country.value = selected.value;
  function updateProvinces(defaultValue) {
    const option = country.options[country.selectedIndex];
    let provinces = [];
    try { provinces = JSON.parse(option?.dataset.provinces || '[]'); } catch {}
    province.replaceChildren();
    for (const [value, label] of provinces) {
      const entry = new Option(label, value);
      entry.selected = value === defaultValue || label === defaultValue;
      province.add(entry);
    }
    container.hidden = provinces.length === 0;
    province.disabled = provinces.length === 0;
  }
  updateProvinces(province.dataset.default);
  country.addEventListener('change', () => updateProvinces(''));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mmInitCustomerAddress);
else mmInitCustomerAddress();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-mobile-nav"] && !Shopify.designMode) return;
  try {
    (() => {
  const nav = document.getElementById('mm-mobile-nav');
  if (!nav) return;
  nav.addEventListener('click', event => {
    const link = event.target.closest('[data-mm-nav-cart], [data-mm-nav-search]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const selector = link.hasAttribute('data-mm-nav-cart') ? '.header-menu-cart-drawer' : '.header-menu-search-popup';
    const opener = document.querySelector(selector);
    if (opener && window.jQuery) {
      event.preventDefault();
      opener.click();
    }
  });
  const source = document.getElementById('header-cart-drawer-item-count');
  const target = nav.querySelector('[data-mm-nav-cart-count]');
  if (source && target) {
    const sync = () => {
      const value = parseInt(source.textContent, 10) || 0;
      target.textContent = value;
      target.hidden = value === 0;
    };
    new MutationObserver(sync).observe(source, { childList: true, characterData: true, subtree: true });
    sync();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-product-bundle"] && !Shopify.designMode) return;
  try {
    function initMMPairings(){
  document.querySelectorAll('.mm-pairing').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const texts=JSON.parse(root.querySelector('.mm-pairing-text').textContent);
    const bundles=JSON.parse(root.querySelector('.mm-pairing-bundle').textContent);
    const rows=Array.from(root.querySelectorAll('.mm-pairing-row')).map(el=>({el,check:el.querySelector('input'),select:el.querySelector('select'),variants:JSON.parse(el.querySelector('.mm-pairing-variants').textContent)}));
    const total=root.querySelector('.mm-pairing-total'),button=root.querySelector('.mm-pairing-add'),status=root.querySelector('.mm-pairing-status');
    const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency:root.dataset.currency||'EUR'}).format(cents/100);
    const variant=row=>row.variants.find(v=>String(v.id)===(row.select?row.select.value:row.el.querySelector('[data-variant]').dataset.variant));
    const selected=()=>rows.filter(row=>row.check.checked);
    const matchBundle=()=>{
      const options=rows.flatMap(row=>{const v=variant(row);return v.options.filter(o=>o!=='Default Title').filter((o,i)=>new Set(row.variants.map(x=>x.options[i])).size>1);});
      return bundles.find(v=>v.options.length===options.length&&v.options.every((o,i)=>o===options[i]));
    };
    function update(){
      const active=selected(),full=active.length===rows.length;
      let sum=0;
      rows.forEach(row=>{
        const v=variant(row),on=row.check.checked;
        row.el.querySelector('.mm-pairing-item').classList.toggle('is-off',!on);
        if(row.select)row.select.disabled=!on;
        const price=row.el.querySelector('.mm-pairing-price');
        price.querySelector('del').hidden=!full;
        price.querySelector('del').textContent=money(v.price);
        price.querySelector('strong').textContent=money(full&&row.el.dataset.discountExempt!=='true'?Math.round(v.price*.9):v.price);
        if(on)sum+=v.price;
      });
      const exemptSum=active.filter(row=>row.el.dataset.discountExempt==='true').reduce((sum,row)=>sum+variant(row).price,0);
      const discounted=full?Math.round((sum-exemptSum)*.9)+exemptSum:sum;
      total.querySelector('del').hidden=!full;
      total.querySelector('del').textContent=money(sum);
      total.querySelector('strong').textContent=money(discounted);
      const b=full?matchBundle():null;
      const available=active.every(r=>variant(r).available);
      button.disabled=!available||(full&&(!b||!b.available||b.price!==discounted));
      status.textContent=!available?texts.unavailable:full&&button.disabled?texts.pending:'';
      button.textContent=texts.add;
    }
    rows.forEach(row=>{row.check.addEventListener('change',update);if(row.select)row.select.addEventListener('change',update);});
    button.addEventListener('click',async()=>{
      if(button.disabled)return;
      button.disabled=true;
      try{
        const active=selected(),full=active.length===rows.length;
        const items=full?[{id:matchBundle().id,quantity:1}]:active.map(row=>({id:variant(row).id,quantity:1}));
        const response=await fetch(texts.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if(!response.ok)throw new Error(texts.error);
        window.location.assign(texts.cart);
      }catch(e){update();status.textContent=texts.error;}
    });
    update();
  });
}
initMMPairings();
document.addEventListener('shopify:section:load',initMMPairings);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-product-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const opener = event.target.closest('[data-mm-size-guide-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.mmSizeGuideOpen);
    if (dialog && !dialog.open) dialog.showModal();
    return;
  }
  const closer = event.target.closest('[data-mm-size-guide-close]');
  if (closer) closer.closest('dialog').close();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-product-warranty"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
 const opener = event.target.closest('[data-mm-warranty-open]');
 if (opener) {
  const dialog = document.getElementById(opener.dataset.mmWarrantyOpen);
  if (!dialog || typeof dialog.showModal !== 'function') return;
  event.preventDefault();
  const image = dialog.querySelector('img[data-src]');
  if (image && !image.src) image.src = image.dataset.src;
  dialog.showModal();
  document.documentElement.classList.add('mm-warranty-open');
  dialog.addEventListener('close', () => document.documentElement.classList.remove('mm-warranty-open'), { once: true });
  return;
 }
 const closer = event.target.closest('[data-mm-warranty-close]');
 if (closer) closer.closest('dialog').close();
 if (event.target.matches('.mm-warranty-dialog')) {
  const b = event.target.getBoundingClientRect();
  if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) event.target.close();
 }
});
  } catch(e) { console.error(e); }
})();

})();
